import { MONUMENT_FIREPOWER_BONUS, tileDefensePercent } from "./buildings";
import { normalizedHpPercent } from "./stacks";
import type { Tile, Unit } from "./types";
import { MAX_HP, UNIT_DEFS, effectiveAttackHp, effectiveAttackKind, isAirUnit } from "./units";

export function computeDamageFromRoll({
  attacker,
  defender,
  defenderTile,
  attackerMonumentCount = 0,
}: {
  attacker: Unit;
  defender: Unit;
  defenderTile: Pick<Tile, "kind">;
  attackerMonumentCount?: number;
}): number {
  const basePct = UNIT_DEFS[effectiveAttackKind(attacker)].damage[defender.kind] ?? 0;
  const hpFactor = normalizedHpPercent(effectiveAttackHp(attacker)) / MAX_HP;
  const defensePercent = isAirUnit(defender.kind) ? 0 : tileDefensePercent(defenderTile);
  const defMult = Math.max(0, 1 - Math.max(0, defensePercent) / 100);
  const firepowerMult = 1 + MONUMENT_FIREPOWER_BONUS * Math.max(0, attackerMonumentCount);
  return Math.ceil(basePct * hpFactor * defMult * firepowerMult);
}
